import React from 'react';
import s from '../../PromoBadge.scss';

export interface Props {
  className?: string;
}

const HexagonLocked40: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M19 .577a2 2 0 0 1 2 0l15.32 8.846a2 2 0 0 1 1 1.732v17.69a2 2 0 0 1-1 1.732L21 39.423a2 2 0 0 1-2 0L3.68 30.577a2 2 0 0 1-1-1.732v-17.69a2 2 0 0 1 1-1.732L19 .577Z"
      className={s['fill-color']}
    />
    <path
      opacity="0.1"
      d="M19 4.327a2 2 0 0 1 2 0l12.073 6.97a2 2 0 0 1 1 1.733v13.94a2 2 0 0 1-1 1.732L21 35.672a2 2 0 0 1-2 0l-12.073-6.97a2 2 0 0 1-1-1.732V13.03a2 2 0 0 1 1-1.732L19 4.328Z"
      className={s['fill-color']}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 8.077a2 2 0 0 0-2 0l-8.825 5.096a2 2 0 0 0-1 1.732v10.19a2 2 0 0 0 1 1.732L19 31.923a2 2 0 0 0 2 0l5-2.887v-2.738a.45.45 0 0 1 .187-.351.738.738 0 0 1 .45-.146h1.489v-2.829c.002-1.318.674-2.582 1.869-3.514.258-.202.536-.384.83-.546v-4.007a2 2 0 0 0-1-1.732L21 8.077Z"
      className={s['fill-color']}
    />
    <path
      d="M34.5 20a4.057 4.057 0 0 0-2.915 1.253 4.36 4.36 0 0 0-1.21 3.021v2.958h-.963a.405.405 0 0 0-.291.125.435.435 0 0 0-.121.303v7.913a.441.441 0 0 0 .12.302.412.412 0 0 0 .292.125h10.176a.401.401 0 0 0 .291-.125.428.428 0 0 0 .121-.302V27.66a.442.442 0 0 0-.12-.303.414.414 0 0 0-.292-.125h-.964v-2.957a4.36 4.36 0 0 0-1.209-3.022A4.057 4.057 0 0 0 34.5 20Zm.686 11.68v1.852c0 .189-.072.37-.2.503a.674.674 0 0 1-.486.208.674.674 0 0 1-.485-.208.725.725 0 0 1-.201-.503V31.68a1.425 1.425 0 0 1-.595-.694 1.489 1.489 0 0 1-.062-.926c.078-.307.252-.579.495-.773.243-.194.541-.299.848-.299.307 0 .605.105.848.3.243.193.417.465.495.772.079.308.057.633-.062.926a1.425 1.425 0 0 1-.595.694Zm-3.095-4.448v-2.957c0-.329.06-.654.181-.958.121-.304.299-.58.522-.812.224-.233.49-.417.783-.543a2.336 2.336 0 0 1 1.846 0c.293.126.559.31.783.543.223.232.4.508.521.812.121.304.183.63.182.957v2.958h-4.818Z"
      className={s['fill-color']}
    />
  </svg>
);
HexagonLocked40.displayName = 'HexagonLocked40';

export default HexagonLocked40;
